import React, {Component} from 'react';

import styled from 'styled-components';

import FontAwesomeIcon from '@fortawesome/react-fontawesome';
import {faChevronLeft, faChevronRight} from '@fortawesome/fontawesome-free-solid';
import anime from 'animejs';
import Defaulf_Img from './vehicleimagenotavailable1.png';

class CarouselSlidePicker extends Component {

    scrollContainerEl = React.createRef()

    scrollLeft() {
        anime({
            targets: this.scrollContainerEl.current,
            scrollLeft: {
                value: '-=150',
                duration: 300,
                elasticity: 0,

                easing: 'easeOutQuad'
            }
        })
    }

    scrollRight() {
        anime({
            targets: this.scrollContainerEl.current,
            scrollLeft: {
                value: '+=150',
                duration: 300,
                elasticity: 0,

                easing: 'easeOutQuad'
            }
        })
    }
    
    render() {

        function imageExists(image_url){

            var http = new XMLHttpRequest();
        
            http.open('HEAD', image_url, false);
            http.send();
        
            return http.status != 404;
        
        }

        const {className} = this.props;

        const {options, value, valueDescription, onChange} = this.props;

        let prefix = '';
        return <div className={className}>
            <div className={'carousel-slide-picker__carousel ' + (options.length > 9 ? 'pad' : '')}>
                {
                    options.length > 9 && <span
                                             onClick={this.scrollLeft.bind(this)}
                                             className="carousel__arrow carousel__arrow--left">
                        <FontAwesomeIcon icon={faChevronLeft} size={'1x'}/>
                    </span>
                }

                <div className={'carousel-slide-picker__option-container parent'} ref={this.scrollContainerEl}>
                    {
                        options.map((item, index) => {
                            var url = `${item.src}`;
                            var url_array = url.split("/");
                            var imgName = url_array[url_array.length-1]; 
                            //   if (!item.trimList) {
                            //     return
                            // }
                            return <div key={index}
                                        onClick={item.trimList ? e => onChange(item.id) : null}
                                        className={'container carousel-slide-picker__option-item ' + (item.id === value ? 'carousel-slide-picker__option-item_active' : '') + (item.trimList ? '' : ' unavailable')}>
                                 <div className="cross-check" title="Not Available"></div>
                                 <span className="cross-cross" title="Not Available"></span>
                                <div className={"colorSwatch c-"+ item.colorPaletteCode.replace('#', '')}>
                                  <span className="colorSwatch-checkmark"></span>
                                  <div className="colorSwatch-color" style={{backgroundColor: item.colorPaletteCode}}></div>
                                </div>
                            </div>
                        })
                    }
                </div>

                {
                    options.length > 9 && <span
                                             onClick={this.scrollRight.bind(this)}
                                             className="carousel__arrow carousel__arrow--right">
                        <FontAwesomeIcon icon={faChevronRight} size={'1x'}/>
                    </span>
                }


            </div>
{/* 
            <p className={'carousel-slide-picker__selected'}>
                {valueDescription}
            </p> */}


        </div>
    }
}

export default styled(CarouselSlidePicker)`

.pad {
  padding-left: 30px;
  padding-right: 30px;

  @media (max-width: 420px) {
    padding-left: 0;
    padding-right: 0;
  }
}
.colorSwatch-checkmark {
  opacity: 0;
  z-index: 5;
  position: relative;
  display: inline-block;    
  width: 17px;
  height: 16px;
  margin-top: 10px;
  margin-right: 8px;
}

.cross-check, .cross-cross {
  display: none;
}

.unavailable {
  .cross-check {
    display: inline-block;
    background-color: #000000;
    z-index: 9;
    position: absolute;
    left: 0;
    opacity: 0.3;
    width: 40px;
    height: 40px;
    border-radius: 50%;
  }
  .cross-cross {
    background-color: #FFF;
    width: 41px;
    height: 1px;
    position: absolute;
    z-index: 10;
    left: 0;
    top: 49%;
    transform: rotate(135deg);
    display: inline-block;
  }


}

.colorSwatch-checkmark::before {
  position: absolute;
  left: 0;
  top: 50%;
  height: 50%;
  width: 2px;
  background-color: #FFF;
  content: "";
  transform: translateX(10px) rotate(-45deg);
  transform-origin: left bottom;
}

.colorSwatch-checkmark::after {
  position: absolute;
  left: 0;
  bottom: 0;
  height: 2px;
  width: 100%;
  background-color: #FFF;
  content: "";
  transform: translateX(10px) rotate(-45deg);
  transform-origin: left bottom;
}
.colorSwatch {
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 1px solid #DBDBDB;
  background-color: #E7E7E7;
  text-align: center;
  position: relative;

  &.c-FFFFFF, &.c-FFF, &.c-ffffff, &.c-fff {
    .colorSwatch-checkmark::before {
      background-color: #000;
    }

    .colorSwatch-checkmark::after {
      background-color: #000;
    }
  }
}

.colorSwatch-color {
  display: inline-block;
  background-color: #FFF;
  border-radius: 50%;
  width: 24px;
  height: 24px;
  text-align: center;
  vertical-align: center;
  line-height: 40px;

  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}

.parent {
  width: 20%;
  float: left;
}

.container {
  display: block;
  width: 100%;
  height: auto;
  position: relative;
  overflow: hidden;
  padding: 16% 0 0 0; /* 34.37% = 100 / (w / h) = 100 / (640 / 220) */
}

.container img {
  display: block;
  max-width: 100%;
  max-height: 100%;
  position: absolute;
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
}
  & {
    max-width: 450px;
    margin: 0 auto 10px;
    padding: 0px 12px;
    text-align: center;
    margin-left: 2.5%;
    @media (max-width: 1000px){
        margin-left: 0;
    }
    @media (min-width: 1000px) {
      margin-left: 0;
      padding-left: 0;
      text-align: left;
      max-width: 100%;
    }
  }
  .carousel__arrow {
    color: #B2B2B2;
  }
  .carousel__arrow:hover {
    color: rgba(25,25,25,0.3);
  }
  .svg-inline--fa.fa-w-10 {
    width: 0.555em;
  }

  .carousel-slide-picker__carousel {
    text-align: center;
    display: flex;
    flex-direction: row;
    position: relative;
    padding-top: 13px;
    > a {
      display: block;
      text-align: center;
    }
  }
  .carousel__arrow--left {
      position: absolute;
      left: 2%;
      top: 35%;
  }
  .carousel__arrow--right {
      position: absolute;
      right: 2%;
      top: 35%;
  }
  .carousel-slide-picker__option-container {
      flex: 1;
      white-space: nowrap;
      overflow-x: auto;
      margin-left: 40px;
      margin-right: 40px;

      @media (max-width: 420px) {
        margin-left: 25px;
        margin-right: 25px;
      }


      width: 100%;
      & {
            -ms-overflow-style: none;  // IE 10+
            overflow: -moz-scrollbars-none;  // Firefox
        }
      &::-webkit-scrollbar { 
            display: none;  // Safari and Chrome
        }
        @media (min-width: 1000px) {
          margin-left: 0;
          margin-right: 0;
        }
  }
  
  .carousel-slide-picker__option-item {
    display: inline-block;
    width: 40px;
    height: 40px;
    padding: 0;

    &:not(:last-child) {
      margin-right: 20px;
    }
    
    > img {
      width: 72px;
      height: 72px;
    }
  }
  
  .carousel-slide-picker__option-item_active .itemActive{
    border-bottom: 4px solid #1DAEED;
    padding-bottom: 2px;
    width: 90px;
    height: 92px;
  }
  .carousel-slide-picker__option-item_active{
    // width: 90px;
    // height: 92px;
    // margin-bottom: -5px;
    // padding-bottom: 1px;
    // position: relative;

    .colorSwatch-color {
      width: 40px;
      height: 40px;
      border: 1px solid #DBDBDB;
    }

    .colorSwatch-checkmark {
      opacity: 1;
    }


  }
  
  .carousel-slide-picker__selected {
    text-align: center;
    margin-top: 12px;
    color: rgba(25,25,25,0.5);
    margin-bottom: 0;
    padding-bottom: 15px;
    @media (max-width: 1000px){
        margin-bottom: 1em;
        border-bottom: 0px;
        padding-bottom: 0px;
    }
    @media (min-width: 1000px) {
      border-bottom: 0;
      text-align: left;
    }
  }

  .flex-row div {
      font-size: 11.5px;
  }
  
`


// WEBPACK FOOTER //
// ./src/components/configurator/CarouselSlidePicker.js